export function Card({
  title,
  subtitle,
  actions,
  children,
  footer,
  interactive = false,
  accent = null, // 'gold' | 'navy'
  className = '',
  onClick,
}) {
  const classes = [
    'card',
    interactive ? 'card--interactive' : '',
    accent ? `card--${accent}-border` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} onClick={onClick}>
      {(title || subtitle || actions) && (
        <div className="card__header">
          <div>
            {title && <h3 className="card__title">{title}</h3>}
            {subtitle && <p className="card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </div>
      )}
      <div className="card__body">{children}</div>
      {footer && <div className="card__footer">{footer}</div>}
    </div>
  );
}

export function StatCard({
  label,
  value,
  hint,
  trend,
  trendType = 'up', // 'up' | 'down'
  icon: Icon,
  iconVariant = 'gold', // 'gold' | 'navy' | 'green' | 'red'
  className = '',
}) {
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-card__top">
        <span className="stat-card__label">{label}</span>
        {Icon && (
          <div className={`stat-card__icon stat-card__icon--${iconVariant}`}>
            <Icon />
          </div>
        )}
      </div>
      <div className="stat-card__value">{value}</div>
      {hint && <div className="stat-card__hint">{hint}</div>}
      {trend && (
        <div className={`stat-card__trend stat-card__trend--${trendType}`}>
          <span>{trendType === 'up' ? '↑' : '↓'}</span>
          <span>{trend}</span>
        </div>
      )}
    </div>
  );
}
